import {
  Heading as ChakraHeading,
  HeadingProps as ChakraHeadingProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps, TextColors } from '../../types'

export type HeadingProps = {
  color?: TextColors
} & SwashbuckleComponentProps<ChakraHeadingProps>

export const Heading = ({
  'data-qa': dataQa,
  color = 'neutral-900',
  className,
  ...chakraProps
}: HeadingProps) => (
  <ChakraHeading
    color={`text-${color}`}
    data-qa={dataQa}
    className={className}
    {...chakraProps}
  />
)

Heading.displayName = 'Heading'
